import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { GridList, GridTile } from 'material-ui/GridList';
import IconButton from 'material-ui/IconButton';
import Delete from 'material-ui/svg-icons/action/delete';
import Dropzone from 'react-dropzone';
import { showNotification } from 'admin-on-rest';
import { push } from 'react-router-redux';
import axios from 'axios';
var Config = require('../../config')

const styles = {
  dropZone: {
    background: '#efefef',
    cursor: 'pointer',
    padding: '1rem',
    textAlign: 'center',
    color: '#999',
    marginTop: '20px',
  },
  gridList: {
    width: '100%',
    marginTop: '30px',
  },
  delete: {
    width: '100%',
    padding: '5px 10px',
    background: '#2D3E50',
    color: '#fff',
    textAlign: 'center',
  },
};

class Gallery extends React.Component {
  componentDidMount() {
  }

  deleteImage = (id, image, i) => {
    var auth_token = localStorage.getItem('auth_token');
    const url = Config.serverUrl+`/api/companies/${id}/delete-image?token=`+auth_token;


    const data = { 'image': image };

    if (window.confirm('Are you sure ?')) {
      axios({
        method: 'PUT',
        url,
        data,
      })
      .then(() => {
        this.props.showNotification('Image deleted successfully, refresh to see changes.');
        this.props.toBoats();
      })
      .catch((e) => {
        console.error(e);
        this.props.showNotification('Error: failed to delete image', 'warning');
      });
    }
  }

  onDrop = (files) => {
    console.log("this.props.record",this.props.record._id);
    const { id } = this.props.record;
    const url = Config.serverUrl+'/api/upload_company_photo';
    const formData = new FormData();

    formData.append('id', id);
    formData.append('foto', files[0]);

      console.log("formData",files[0]);
    fetch(url, { method: 'POST', body: formData })
    .then(() => {
      this.props.showNotification('Upload complete, refresh to see changes.');
      this.props.toBoats();
    })
    .catch((e) => {
      console.error(e);
      this.props.showNotification('Error: upload failed', 'warning');
    });
  }

  render() {
    const { id, gallery } = this.props.record;
    return (
      <div>
        <Dropzone
          style={styles.dropZone}
          multiple={false}
          accept="image/*"
          onDrop={this.onDrop}
        >
          Click to upload an image
        </Dropzone>

        <GridList cellHeight={180} cols={4} style={styles.gridList}>
          {gallery && gallery.map((image, i) => (
            <GridTile
              key={image}
              title={`image-${i}`}
              actionIcon={<IconButton onClick={() => this.deleteImage(id, image, i)} ><Delete color="white"/></IconButton>}
            >
              <img src={image} alt="" />
            </GridTile>
          ))}
        </GridList>
      </div>

    );
  }

}

Gallery.propTypes = {
  showNotification: PropTypes.func,
  toBoats: PropTypes.func,
};

function mapDispatchToProps(dispatch) {
  return {
    toBoats: () => {
      dispatch(push('/companies'));
    },
    showNotification: (text) => {
      dispatch(showNotification(text));
    }
  };
}

export default connect(null, mapDispatchToProps)(Gallery);



// WEBPACK FOOTER //
// ./src/pages/companies/gallery.js